import React, { useContext, useEffect, useState } from "react";
import LoadingAction from "../../../../themes/LoadingAction/LoadingAction";
import "./AdminEditPagamento.css";
import { Button, Input, Switch, Divider, Tooltip, Modal } from "antd";
import { AuthContext } from "../../../../contexts/AuthContext";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import * as links from "../../../../utils/links";
import axios from "axios";
import question_icon from "../../../../assets/images/question.png";
import { QuestionCircleOutlined, PlusOutlined, DeleteOutlined, DownloadOutlined } from "@ant-design/icons";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";

const parseJsonMaybe = (value) => {
  if (typeof value !== "string") return value;
  const s = value.trim();
  if (!s) return value;
  try {
    return JSON.parse(s);
  } catch (_) {
    return value;
  }
};

const normalizeBonusMetodos = (raw) => {
  const v = parseJsonMaybe(raw);
  if (Array.isArray(v)) return v.filter((x) => typeof x === "string" && x);
  return [];
};

const normalizeBonusRegras = (raw) => {
  const v0 = parseJsonMaybe(raw);
  const v =
    v0 && typeof v0 === "object" && !Array.isArray(v0)
      ? v0.regras ?? v0.rules ?? v0.bonusRegras ?? v0
      : v0;
  if (!Array.isArray(v)) return [];
  return v
    .map((it) => {
      const item = parseJsonMaybe(it);
      if (!item || typeof item !== "object") return null;
      const valorMinimo = Number(item.valorMinimo ?? item.valor_minimo ?? item.valor ?? item.min ?? item.value) || 0;
      const bonus = Number(item.bonus ?? item.extra ?? item.bonusValor) || 0;
      return { valorMinimo, bonus };
    })
    .filter(Boolean)
    .sort((a, b) => a.valorMinimo - b.valorMinimo);
};

const AdminEditPagamento = (props) => {
  const location = useLocation();
  let navigate = useNavigate();

  const { maquinaInfos, clienteInfo } = location.state;

  const { authInfo, setNotiMessage } = useContext(AuthContext);

  const [data, setData] = useState({
    nome: maquinaInfos?.nome ?? "",
    descricao: maquinaInfos?.descricao ?? "",
    estoque: Number(maquinaInfos?.estoque) ?? 0,
    store_id: Number(maquinaInfos?.store_id) ?? 0,
    maquininha_serial: String(maquinaInfos?.maquininha_serial),
    valorDoPulso: maquinaInfos?.pulso ?? 0,
    bonusMetodos: normalizeBonusMetodos(maquinaInfos?.bonusMetodos),
    bonusAtivo: maquinaInfos?.bonusAtivo ?? false,
    bloqueadaMensalidade: maquinaInfos?.bloqueadaMensalidade ?? false,
    bonusRegras: normalizeBonusRegras(maquinaInfos?.bonusRegras).length
      ? normalizeBonusRegras(maquinaInfos?.bonusRegras)
      : [
      { valorMinimo: 10, bonus: 2 },
      { valorMinimo: 20, bonus: 4 },
      { valorMinimo: 50, bonus: 10 }
    ],
  });
  const [errors, setErrors] = useState({});

  const [isLoading, setIsLoading] = useState(false);

  const token = authInfo?.dataUser?.token;

  const { id } = useParams();
useEffect(() => {
  if (!id) return;

  setIsLoading(true);

  axios
    .get(`${process.env.REACT_APP_SERVIDOR}/maquina/${id}`, {
      headers: {
        "x-access-token": token,
      },
    })
    .then((res) => {
      const maquina = res.data;

      setData((prev) => ({
        ...prev,
        nome: maquina.nome || "",
        descricao: maquina.descricao || "",
        estoque: Number(maquina.estoque) || 0,
        store_id: Number(maquina.store_id) || 0,
        maquininha_serial: maquina.maquininha_serial || "",
        valorDoPulso: maquina.valorDoPulso || 0,
        bonusAtivo: maquina.bonusAtivo || false,
        bloqueadaMensalidade: maquina.bloqueadaMensalidade ?? false,
        bonusMetodos: normalizeBonusMetodos(maquina.bonusMetodos),
        bonusRegras: normalizeBonusRegras(maquina.bonusRegras),
      }));

      setIsLoading(false);
    })
    .catch(() => {
      setIsLoading(false);
    });
}, [id, token]);
  const handleChange = (name, value) => {
    setData((prev) => ({
      ...prev,
      [name]: value,
    }));
    setErrors((prev) => {
      let errorsTemp = { ...prev };
      delete errorsTemp[name];
      return errorsTemp;
    });
  };
  const toggleMetodo = (metodo) => {
  setData((prev) => {
    const lista = prev.bonusMetodos || [];

    const exists = lista.includes(metodo);

    return {
      ...prev,
      bonusMetodos: exists
        ? lista.filter((m) => m !== metodo)
        : [...lista, metodo],
    };
  });
};

  const handleRuleChange = (index, field, value) => {
    const newRules = [...data.bonusRegras];
    newRules[index][field] = Number(value);
    setData((prev) => ({ ...prev, bonusRegras: newRules }));
  };

  const addRule = () => {
    const newRules = [...data.bonusRegras, { valorMinimo: 0, bonus: 0 }];
    setData((prev) => ({ ...prev, bonusRegras: newRules }));
  };

  const removeRule = (index) => {
    const newRules = data.bonusRegras.filter((_, i) => i !== index);
    setData((prev) => ({ ...prev, bonusRegras: newRules }));
  };

  const downloadBonusPDF = async () => {
    const element = document.getElementById("bonus-table-pdf");
    if (!element) return;

    try {
      setIsLoading(true);
      const canvas = await html2canvas(element, {
        scale: 2,
        backgroundColor: "#ffffff",
      });
      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF("p", "mm", "a4");
      const imgProps = pdf.getImageProperties(imgData);
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;
      
      pdf.addImage(imgData, "PNG", 0, 10, pdfWidth, pdfHeight);
      pdf.save(`bonus-maquina-${data.nome}.pdf`);
    } catch (error) {
      console.error("Erro ao gerar PDF:", error);
      setNotiMessage({ type: "error", message: "Erro ao gerar o PDF de bônus." });
    } finally {
      setIsLoading(false);
    }
  };

  const onSave = () => {
  // ===== VALIDAÇÕES (mantidas) =====
  let errorsTemp = {};

  if (data.nome.trim() === "") {
    errorsTemp.nome = "Este campo é obrigatório";
  }

  if (data.descricao.trim() === "") {
    errorsTemp.descricao = "Este campo é obrigatório";
  }

  if (data.valorDoPulso < 0) {
    errorsTemp.valorDoPulso = "Este campo é obrigatório";
  }

  if (data.estoque < 0) {
    errorsTemp.estoque = "Estoque é obrigatório";
  }

  if (Object.keys(errorsTemp).length > 0) {
    setErrors(errorsTemp);
    return;
  }

  // ===== FUNÇÃO DE SALVAR (axios original) =====
  const executarSalvamento = () => {
  console.log("BLOQUEIO AO SALVAR:", data.bloqueadaMensalidade);

  setIsLoading(true);

    axios
      .put(
        `${process.env.REACT_APP_SERVIDOR}/maquina`,
        {
          id,
          nome: data.nome,
          descricao: data.descricao,
          estoque: Number(data.estoque),
          store_id: String(data.store_id),
          maquininha_serial: String(data.maquininha_serial),
          valorDoPulso: data.valorDoPulso,
          bonusAtivo: data.bonusAtivo,
          bonusMetodos: data.bonusMetodos,
          bonusRegras: data.bonusRegras,
          bloqueadaMensalidade: data.bloqueadaMensalidade,
        },
        {
          headers: {
            "x-access-token": token,
            "content-type": "application/json",
          },
        }
      )
      .then((res) => {
        setIsLoading(false);
        navigate(`${links.CLIENTES_MAQUINAS}/${clienteInfo.id}`, {
          state: location.state.clienteInfo,
        });
      })
      .catch((err) => {
        setIsLoading(false);

        if ([401, 403].includes(err.response.status)) {
          setNotiMessage({
            type: "error",
            message:
              "A sua sessão expirou, para continuar faça login novamente.",
          });
        } else if (err.response.status === 400) {
          setNotiMessage({
            type: "error",
            message: `${err.response.data.error}`,
          });
          setErrors((prev) => ({
            ...prev,
            nome: "Já existe uma máquina com esse nome",
          }));
        } else {
          setNotiMessage({
            type: "error",
            message: "Um erro ocorreu",
          });
        }
      });
  };

  // ===== CONFIRMAÇÃO DO BONUS =====
  if (data.bonusAtivo) {
    Modal.confirm({
      title: "Confirmação de Jogada Bônus",
      content: (
  <div style={{ fontSize: '14px' }}>
    <p>
      Você está salvando a jogada bônus com{" "}
      <b>{data.bonusRegras.length}</b> regras configuradas.
    </p>

    <div style={{
      marginTop: 10,
      padding: 10,
      background: '#fffbe6',
      border: '1px solid #ffe58f',
      borderRadius: 6
    }}>
      ⚠️ <b>IMPORTANTE</b>
      <br />
      Cada pulso equivale a <b>R$ 1,00</b>.
    </div>

    <p style={{ marginTop: 10 }}>
  👉 Cada máquina pode ter um valor diferente por jogada,
  configurado diretamente no equipamento.
</p>

<p>
  👉 Regra geral: <b>1 pulso = R$ 1,00</b>.
</p>

<p>
  👉 Portanto, para liberar 1 jogada:
  <br />
  - Máquina de R$ 2 → 2 pulsos
  <br />
  - Máquina de R$ 5 → 5 pulsos
</p>

    <div style={{
      marginTop: 10,
      padding: 10,
      background: '#f6ffed',
      border: '1px solid #b7eb8f',
      borderRadius: 6
    }}>
      <b>Exemplo:</b>
      <br />
      R$ 2 → 2 pulsos = 1 jogada
      <br />
      R$ 5 → 5 pulsos = 1 jogada
    </div>

    <p style={{ marginTop: 10 }}>
      Deseja continuar?
    </p>
  </div>
),
      okText: "Sim, salvar",
      cancelText: "Cancelar",
      onOk: () => executarSalvamento(),
    });

    return;
  }

  // ===== SEM BONUS =====
  executarSalvamento();
};

  return (
    <div className="Admin_PagamentosSearch_container">
      {isLoading && <LoadingAction />}
      <div className="Admin_PagamentosSearch_header">
        <div className="Admin_PagamentosSearch_header_left">
          <div className="Admin_Dashboard_staBlockTitle">Editar Máquina</div>
        </div>

        <Button
          className="Admin_EditPagamentos_header_back"
          onClick={() => {
            navigate(`${links.CLIENTES_MAQUINAS_FORNECEDOR_SEARCH}/${id}`, {
              state: location.state,
            });
          }}
        >
          <span>VOLTAR</span>
        </Button>
      </div>

      <div className="Admin_Update_Pagamento_content">
        <div className="Admin_Update_Pagamento_itemField">
          <label
            className="Admin_Update_Pagamento_itemFieldLabel"
            htmlFor="nome"
          >
            Nome:
          </label>
          <Input
            placeholder={"Máquina 1"}
            value={data.nome}
            id="nome"
            type="text"
            name="nome"
            autoComplete="nome"
            onChange={(event) => {
              handleChange("nome", event.target.value);
            }}
            className={`${
              !!errors.nome ? "Admin_Update_Pagamento_inputError" : ""
            }`}
          />
          {errors.nome && (
            <div className="Admin_Update_Pagamento_itemFieldError">
              {errors.nome}
            </div>
          )}
        </div>
        <div className="Admin_Update_Pagamento_itemField">
          <label
            className="Admin_Update_Pagamento_itemFieldLabel"
            htmlFor="descricao"
          >
            Descricão:
          </label>
          <Input
            placeholder={"Máquina da padaria de juquinha"}
            value={data.descricao}
            id="descricao"
            type="text"
            name="descricao"
            autoComplete="descricao"
            onChange={(event) => {
              handleChange("descricao", event.target.value);
            }}
            className={`${
              !!errors.descricao ? "Admin_Update_Pagamento_inputError" : ""
            }`}
          />
          {errors.descricao && (
            <div className="Admin_Update_Pagamento_itemFieldError">
              {errors.descricao}
            </div>
          )}
        </div>

        <div className="Admin_Update_Pagamento_itemField">
          <label
            className="Admin_Update_Pagamento_itemFieldLabel"
            htmlFor="store_id"
            style={{ display: "flex", alignItems: "center" }}
          >
            <span>Store_id:</span>
            <Button
              className="Admin_EditPagamentos_header_HelpPage"
              onClick={() => {
                navigate(links.HELP_PAGE, {
                  state: {
                    ...location.state,
                    redirect_url: `${links.CLIENTES_MAQUINAS_EDIT_FORNECEDOR}/${id}`,
                  },
                });
              }}
              disabled={isLoading}
            >
              <img
                className="Admin_Edit_Pagamento_Icon"
                src={question_icon}
                alt="question icon"
              />
            </Button>
          </label>
          <Input
            placeholder={"12345678"}
            value={data.store_id}
            id="store_id"
            name="store_id"
            min={0}
            autoComplete="store_id"
            onChange={(event) => {
              handleChange("store_id", event.target.value);
            }}
            className={`${
              !!errors.store_id ? "Admin_Update_Pagamento_inputError" : ""
            }`}
          />
          {errors.store_id && (
            <div className="Admin_Update_Pagamento_itemFieldError">
              {errors.store_id}
            </div>
          )}
        </div>
        <div className="AddMachine_itemField">
            <label className="AddMachine_itemFieldLabel" htmlFor="maquininha_serial">
              Maquininha_serial:
            </label>
            <Input
              placeholder={""}
              value={data.maquininha_serial}
              id="maquininha_serial"
              name="maquininha_serial"
              min={0}
              autoComplete="maquininha_serial"
              onChange={(event) => {
                handleChange("maquininha_serial", event.target.value);
              }}
              className={`${!!errors.maquininha_serial ? "AddMachine_inputError" : ""}`}
            />
            {errors.maquininha_serial && (
              <div className="AddMachine_itemFieldError">{errors.maquininha_serial}</div>
            )}
          </div>
        <div className="Admin_Update_Pagamento_itemField">
          <label
            className="Admin_Update_Pagamento_itemFieldLabel"
            htmlFor="valorDoPulso"
          >
            Valor Do Pulso R$:
          </label>
          <Input
            placeholder={"1.50"}
            value={data.valorDoPulso}
            id="valorDoPulso"
            type="number"
            name="valorDoPulso"
            autoComplete="valorDoPulso"
            onChange={(event) => {
              handleChange("valorDoPulso", event.target.value);
            }}
            className={`${
              !!errors.valorDoPulso ? "Admin_Update_Pagamento_inputError" : ""
            }`}
          />
          {errors.valorDoPulso && (
            <div className="Admin_Update_Pagamento_itemFieldError">
              {errors.valorDoPulso}
            </div>
          )}
        </div>
        <div className="Admin_Update_Pagamento_itemField">
          <label
            className="Admin_Update_Pagamento_itemFieldLabel"
            htmlFor="estoque"
          >
            Estoque:
          </label>
          <Input
            placeholder={"1.50"}
            value={data.estoque}
            id="estoque"
            type="number"
            name="estoque"
            autoComplete="estoque"
            onChange={(event) => {
              handleChange("estoque", event.target.value);
            }}
            className={`${
              !!errors.estoque ? "Admin_Update_Pagamento_inputError" : ""
            }`}
          />
          {errors.estoque && (
            <div className="Admin_Update_Pagamento_itemFieldError">
              {errors.estoque}
            </div>
          )}
        </div>
          <Divider orientation="left">Controle da Máquina</Divider>

<div
  className="Admin_Update_Pagamento_itemField"
  style={{
    display: "flex",
    alignItems: "center",
    gap: "10px",
    marginBottom: "20px",
  }}
>
  <label
    className="Admin_Update_Pagamento_itemFieldLabel"
    style={{ marginBottom: 0 }}
  >
    Bloquear por Mensalidade:
  </label>

  <Switch
    checked={data.bloqueadaMensalidade}
    onChange={(checked) =>
      handleChange("bloqueadaMensalidade", checked)
    }
  />

  <span
    style={{
      fontWeight: "bold",
      color: data.bloqueadaMensalidade ? "#ff4d4f" : "#52c41a",
    }}
  >
    {data.bloqueadaMensalidade ? "BLOQUEADA" : "LIBERADA"}
  </span>
</div>

        <Divider orientation="left">Configuração de Bônus</Divider>

        <div className="Admin_Update_Pagamento_itemField" style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '10px' }}>
  <label className="Admin_Update_Pagamento_itemFieldLabel" style={{ marginBottom: 0 }}>
    Ativar Jogada Bônus:
  </label>

  <Switch 
    checked={data.bonusAtivo} 
    onChange={(checked) => handleChange("bonusAtivo", checked)} 
  />

  <Tooltip title="Quando ativo, o sistema libera pulsos extras automaticamente conforme o valor pago.">
    <QuestionCircleOutlined style={{ fontSize: '16px', color: '#1890ff', cursor: 'help' }} />
  </Tooltip>
</div>

{/* 👇 AGORA FORA DA DIV */}
{data.bonusAtivo && (
  <div style={{ marginBottom: '20px' }}>
    <p style={{ fontWeight: 'bold' }}>Aplicar bônus para:</p>

    <div style={{ display: 'flex', gap: '10px' }}>
      {["PIX", "CREDITO", "DEBITO", "ESPECIE"].map((metodo) => (
        <Button
  style={{ minWidth: '90px' }}
          key={metodo}
          type={(data.bonusMetodos || []).includes(metodo) ? "primary" : "default"}
          onClick={() => toggleMetodo(metodo)}
        >
          {metodo}
        </Button>
      ))}
    </div>
  </div>
)}

        {data.bonusAtivo && (
          <div className="Admin_Bonus_Rules_Container" style={{ marginBottom: '20px' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px' }}>
              <p style={{ fontWeight: 'bold', margin: 0 }}>Regras de Bônus:</p>
              <div style={{ display: 'flex', gap: '8px' }}>
                <Button 
                  type="dashed" 
                  onClick={addRule} 
                  icon={<PlusOutlined />}
                  size="small"
                >
                  Adicionar Regra
                </Button>
                <Button 
                  type="default" 
                  onClick={downloadBonusPDF} 
                  icon={<DownloadOutlined />}
                  size="small"
                >
                  Baixar Tabela PDF
                </Button>
              </div>
            </div>
            {data.bonusRegras.map((regra, index) => (
              <div key={index} style={{ display: 'flex', gap: '10px', marginBottom: '10px', alignItems: 'center' }}>
                <span>Se pagar R$</span>
                <Input 
                  type="number" 
                  value={regra.valorMinimo} 
                  style={{ width: '80px' }}
                  onChange={(e) => handleRuleChange(index, "valorMinimo", e.target.value)}
                />
                <span>libera +</span>
                <Input 
                  type="number" 
                  value={regra.bonus} 
                  style={{ width: '60px' }}
                  onChange={(e) => handleRuleChange(index, "bonus", e.target.value)}
                />
                <span>pulsos</span>
                <Button 
                  type="text" 
                  danger 
                  icon={<DeleteOutlined />} 
                  onClick={() => removeRule(index)}
                  disabled={data.bonusRegras.length <= 1}
                />
              </div>
            ))}
            
            {/* Template Invisível para o PDF */}
            <div id="bonus-table-pdf" style={{ 
              position: 'absolute', 
              left: '-9999px', 
              width: '600px', 
              padding: '40px', 
              textAlign: 'center',
              fontFamily: 'Arial, sans-serif',
              border: '2px solid #1890ff',
              borderRadius: '15px',
              backgroundColor: '#fff',
              color: '#111'
            }}>
              <h1 style={{ color: '#1890ff', fontSize: '32px', marginBottom: '10px' }}>JOGADA BÔNUS ATIVA! 🚀</h1>
              <p style={{ fontSize: '18px', fontWeight: 'bold', marginBottom: '20px' }}>
                💳 Métodos:{" "}
                {data.bonusMetodos?.length
                  ? data.bonusMetodos.join(" • ")
                  : "Nenhum"}
              </p>
              <p style={{ fontSize: '18px', color: '#666', marginBottom: '30px' }}>
                Cada jogada custa R$ 2,00. Aproveite os bônus abaixo:
              </p>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
                {data.bonusRegras.map((regra, index) => {
                  const jogadasNormais = Math.floor(regra.valorMinimo / 2);
                  const jogadasBonus = Math.floor(regra.bonus / 2);
                  const totalJogadas = jogadasNormais + jogadasBonus;
                  return (
                    <div key={index} style={{ 
                      backgroundColor: '#f0f2f5', 
                      padding: '20px', 
                      borderRadius: '10px',
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                      border: '1px solid #d9d9d9'
                    }}>
                      <div style={{ textAlign: 'left' }}>
                        <span style={{ fontSize: '24px', fontWeight: 'bold', color: '#111' }}>R$ {regra.valorMinimo},00</span>
                      </div>
                      <div style={{ textAlign: 'right' }}>
                        <span style={{ fontSize: '20px', color: '#1890ff', fontWeight: 'bold' }}>
                          {jogadasNormais} + {jogadasBonus} BÔNUS = {totalJogadas} JOGADAS!
                        </span>
                      </div>
                    </div>
                  );
                })}
              </div>
              <p style={{ marginTop: '40px', fontSize: '14px', color: '#333', fontWeight: 'bold' }}>
                Obs: em espécie tem que ser nota única (ex: 1 nota de R$ 20,00) conforme bônus a cima.
              </p>

              {/* Rodapé com Logo e Telefone */}
              <div style={{ 
                marginTop: '30px', 
                paddingTop: '20px', 
                borderTop: '1px solid #eee',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                gap: '5px'
              }}>
                <div style={{ 
                  fontSize: '18px', 
                  fontWeight: 'bold', 
                  color: '#000000',
                  letterSpacing: '1px'
                }}>
                  Oferecimento: IkPay sistema
                </div>
              </div>
            </div>
          </div>
        )}

        <Button
          className="Admin_Update_Pagamento_saveBtn"
          onClick={() => {
            if (!isLoading) onSave();
          }}
          disabled={isLoading}
        >
          SALVAR ALTERAÇÕES
        </Button>
        <Button
          className="Admin_Update_Pagamento_deleteBtn"
          onClick={() => {
            navigate(`${links.CLIENTES_MAQUINAS_DELETE_FORNECEDOR}/${id}`, {
              state: location.state,
            });
          }}
          disabled={isLoading}
        >
          EXCLUIR MÁQUINA
        </Button>
      </div>
    </div>
  );
};

export default AdminEditPagamento;
